import { DamageDetailsResponse, VideoDetails } from "../../api-models/DamageDetailsResponse";
import { InspectionLockDetails } from "../../api-models/response/InspectionLockDetails";
import { MediaFileResponse } from "../../api-models/response/MediaFileResponse";
import { NameEntityResponse } from "../../api-models/response/NameEntityResponse";
import { BaseTechnicalInspection } from "../technical-inspection/BaseTechnicalInspection";
import { DynamicProperty } from "../../components/data-components/DynamicProperty";
import {
  PropertyMetadata,
  DynamicPropertyResponse,
} from "../../api-models/response/DynamicProperty";
import { DamageMetadataResponse } from "../../api-models/response/DamageMetadataResponse";

export class DamageDetails extends BaseTechnicalInspection {
  id: number;
  sectionId: string;
  inspectionId: string;
  inspectionLockDetails: InspectionLockDetails;
  image?: MediaFileResponse;
  videoDetails: VideoDetails;
  created: Date;
  createdBy: NameEntityResponse;
  mainCodeFieldIndicator: string;
  c1CodeFieldIndicator: string;
  c2CodeFieldIndicator: string;
  quantification1FieldIndicator: string;
  quantification2FieldIndicator: string;

  constructor(damage: DamageDetailsResponse) {
    super(damage.dynamicProperties, damage.genericIssues);
    this.id = damage.id;
    this.sectionId = damage.sectionId;
    this.inspectionId = damage.inspectionId;
    this.inspectionLockDetails = damage.inspectionLockDetails;
    this.image = damage.image;
    this.videoDetails = damage.videoDetails;
    this.created = damage.created;
    this.createdBy = damage.createdBy;
    this.mainCodeFieldIndicator = damage.mainCodeFieldIndicator;
    this.c1CodeFieldIndicator = damage.c1CodeFieldIndicator;
    this.c2CodeFieldIndicator = damage.c2CodeFieldIndicator;
    this.quantification1FieldIndicator = damage.quantification1FieldIndicator;
    this.quantification2FieldIndicator = damage.quantification2FieldIndicator;
  }

  static create(damageMetadata: DamageMetadataResponse) {
    const emptyDamage = Object.create(this.prototype);
    emptyDamage.id = 0;
    emptyDamage.sectionId = "";
    emptyDamage.inspectionId = "";
    emptyDamage.inspectionLockDetails = null;
    emptyDamage.dynamicProperties = [];
    emptyDamage.mainCodeFieldIndicator = "";
    emptyDamage.c1CodeFieldIndicator = "";
    emptyDamage.c2CodeFieldIndicator = "";
    emptyDamage.quantification1FieldIndicator = "";
    emptyDamage.quantification2FieldIndicator = "";
    emptyDamage.image = undefined;
    emptyDamage.videoDetails = {
      videoPosition: "",
      station: "",
      inspectionCode: "",
    };
    emptyDamage.created = new Date();
    emptyDamage.createdBy = {
      id: 0,
      name: "",
      isDeleted: false,
    };
    emptyDamage.mainCodeFieldIndicator = damageMetadata.mainCodeFieldIndicator;
    emptyDamage.c1CodeFieldIndicator = damageMetadata.c1CodeFieldIndicator;
    emptyDamage.c2CodeFieldIndicator = damageMetadata.c2CodeFieldIndicator;
    emptyDamage.quantification1FieldIndicator = damageMetadata.quantification1FieldIndicator;
    emptyDamage.quantification2FieldIndicator = damageMetadata.quantification2FieldIndicator;
    return emptyDamage;
  }

  setDynamicProperties(items: PropertyMetadata[]) {
    this.dynamicProperties = this.createDynamicPropertiesFromMetadata(items);
  }

  private createDynamicPropertiesFromMetadata(items: PropertyMetadata[]): DynamicProperty[] {
    const dynamicProperties: DynamicProperty[] = items.map((item) => {
      const property: DynamicPropertyResponse = { metadata: item, value: "", issues: [] };
      return new DynamicProperty(property);
    });

    return dynamicProperties;
  }

  getPropertiesForEditNotInList(indicators: string[]) {
    const dynamicPropertiesForEdit = this.getDynamicPropertiesForEdit();
    return dynamicPropertiesForEdit.filter(
      (x) => !indicators.some((code) => code === x.metadata.indicator)
    );
  }
}
